module.exports = __webpack_public_path__ + "static/media/WEB6.38ed1b8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/WEB6.jpg
// module id = 82
// module chunks = 0